import { ActivityRootState } from './activityStore';

export const selectActivityItems = (state: ActivityRootState) => state.activity.items;

export const selectSelectedActivityItem = (state: ActivityRootState) =>
  state.activity.selectedItem;

export const selectActivityPagination = (state: ActivityRootState) =>
  state.activity.pagination;

export const selectActivityFilters = (state: ActivityRootState) => state.activity.filters;

export const selectActivitySort = (state: ActivityRootState) => state.activity.sort;

export const selectActivityIsLoading = (state: ActivityRootState) => state.activity.isLoading;

export const selectActivityError = (state: ActivityRootState) => state.activity.error;

export const selectFilterOptions = (state: ActivityRootState) => state.activity.filterOptions;

export const selectFilterOptionsLoading = (state: ActivityRootState) =>
  state.activity.filterOptionsLoading;

export const selectFilterOptionsError = (state: ActivityRootState) =>
  state.activity.filterOptionsError;

export const selectAccessibleCustomers = (state: ActivityRootState) =>
  state.activity.accessibleCustomers;

export const selectAccessibleCustomersLoading = (state: ActivityRootState) =>
  state.activity.accessibleCustomersLoading;

export const selectAccessibleCustomersError = (state: ActivityRootState) =>
  state.activity.accessibleCustomersError;

export const selectAccessibleCustomersByOrgCache = (state: ActivityRootState) =>
  state.activity.accessibleCustomersByOrgCache || {};

export const selectColumnConfig = (state: ActivityRootState) => state.activity.columnConfig;

export const selectRetryingTaskIds = (state: ActivityRootState) => state.activity.retryingTaskIds;
export const selectRetryingWorkflowIds = (state: ActivityRootState) => state.activity.retryingWorkflowIds;
export const selectHasLoadedOnce = (state: ActivityRootState) => state.activity.hasLoadedOnce;
export const selectCustomerId = (state: ActivityRootState) => state.activity.customerId;
export const selectCustomerIds = (state: ActivityRootState) => state.activity.customerIds;
export const selectPendingToast = (state: ActivityRootState) => state.activity.pendingToast;
export const selectUserDisplayNames = (state: ActivityRootState) => state.activity.userDisplayNames;

export const selectIsLoadingUserNames = (state: ActivityRootState) => state.activity.isLoadingUserNames;

export const selectUserNamesError = (state: ActivityRootState) => state.activity.userNamesError;
